import { Route } from 'types/route.type';
import TreatmentCatalog from './treatment-catalog';

export const routes: Route[] = [
  {
    path: '/self-service/treatment-catalog/',
    component: TreatmentCatalog,
    id: 'selfService.treatmentCatalog.title',
  },
];
